
import * as prismic from '@prismicio/client'
import { appConfig } from './Config'; 

export const repositoryName = appConfig.prismicRepository;
export const prismicClient = prismic.createClient(repositoryName)